import { useMutation } from "react-query";
import http from "infra/http";
import { EnderecoDto } from "core/features/unidades/typings/unidade";

function useSaveClienteEndereco(id: string) {
  return useMutation(
    `/v1/cliente/${id}/endereco`,
    (data: EnderecoDto) => {
      return http.put<{ id: string }>(`/v1/cliente/${id}/endereco`, data);
    },
    { retry: false }
  );
}

export default useSaveClienteEndereco;
